import { initialValues, nhanVienSchema, type NhanVienFormValues } from '../../schemas';
import { HeaderBar, AritoFormV2 } from '@/components/custom/erp';
import { NhanVien, NhanVienInput } from '@/types/schemas';
import { useSearchFieldStates } from '../../hooks';
import BasicInfoTab from './BasicInfoTab';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: NhanVienInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: NhanVien;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

export const FormDialog: React.FC<FormDialogProps> = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}) => {
  const { department, setDepartment, location, setLocation } = useSearchFieldStates(initialData);

  const handleSubmit = async (data: NhanVienFormValues) => {
    try {
      const formattedData = {
        ...data,
        ma_bo_phan: department?.uuid,
        noi_cap_cmnd: location?.uuid
      } as NhanVienInput;

      onSubmit(formattedData);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <AritoFormV2
      mode={formMode}
      title={formMode === 'add' ? 'Mới' : undefined}
      onClose={onClose}
      onSubmit={handleSubmit}
      initialData={initialData || initialValues}
      schema={nhanVienSchema}
      hasAritoActionBar={false}
      headerBar={
        <HeaderBar
          onClose={onClose}
          mode={formMode}
          title='Mới'
          subTitle='Danh mục nhân viên'
          onAdd={onAddButtonClick}
          onEdit={onEditButtonClick}
          onDelete={onDeleteButtonClick}
          onCopy={onCopyButtonClick}
        />
      }
      headerFields={
        <BasicInfoTab
          formMode={formMode}
          department={department}
          location={location}
          setDepartment={setDepartment}
          setLocation={setLocation}
        />
      }
    />
  );
};

export default FormDialog;
